import React, { useState, useEffect } from "react";
import {
  ListItemIcon,
  Menu,
  MenuItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
// import {
//   getCustomerDashboard,
//   selectOtpState,
// } from "../../../../src/slice/customerDashboardSlice";
// import { clearUserDetails } from "../../../../src/slice/LoginPageSlice";
// import { setloginSliderstate } from "../../../../src/slice/LoginPageSlice";
import { getCustomerDashboard } from "../../../../Redux/Actions";

// SVG IMPORTS
import AddressIcon from "../../../../Assets/svg/address.svg"
import CardIcon from "../../../../Assets/svg/credit-card.svg"
import HelpIcon from "../../../../Assets/svg/help.svg"
import OrdersIcon from "../../../../Assets/svg/orders.svg"
import PresIcon from "../../../../Assets/svg/prescription-profile-menu.svg"
import WalletIcon from "../../../../Assets/svg/wallet.svg"
import FamilyFriendsIcon from "../../../../Assets/svg/family-friends.svg"
import GiftCardIcon from "../../../../Assets/svg/gift-card.svg"
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { RiLogoutBoxLine } from "react-icons/ri";
// END SVG IMPORTS

// USER CAN ONLY ACCESS PROFILE MENU WHEN LOGGED IN

const ProfileMenu = ({
  showProfileMenu,
  setShowProfileMenu,
  menuAnchorEl,
  menuFontSize,
}) => {
  const menuItems = [
    {
      name: "Personal Information",
      href: "/userprofile",
      Icon: CardIcon,
    },
    {
      name: "My Orders",
      href: "/orders",
      Icon: OrdersIcon,
    },
    {
      name: "My Family & Friends",
      href: "/familyfriends",
      Icon: FamilyFriendsIcon,
    },
    {
      name: "My Addresses",
      href: "/myaddress",
      Icon: AddressIcon,
    },
    {
      name: "My Prescription",
      href: "/prescription",
      Icon: PresIcon,
    },
    {
      name: "My RedCash",
      href: "/myredcash",
      Icon: WalletIcon,
    },
    {
      name: "My Gift Card",
      href: "/subscription",
      Icon: GiftCardIcon,
    },
    {
      name: "Help & Support",
      href: "/helpandsupport",
      Icon: HelpIcon,
    },
  ];
  // const router = useRouter();
  const dispatch = useDispatch();
  const customerData = useSelector((state) => state.customerDashboard.packages);
  const customerDetails = customerData?.profile ?? {};

  useEffect(() => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const token = user?.token;
      if (token) {
        dispatch(getCustomerDashboard(token));
      }
    } catch {
      //console.log("User Details Not Found")
    }
  }, []);

  const handleItemClick = (href, index) => {
    window.location.href = process.env.RAZZLE_APP_BASE_URL + "/dashboard" + href;
    // router.push(`/dashboard${href}`);
  };

  const handleMenuClose = () => {
    setShowProfileMenu(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    // dispatch(clearUserDetails());
    window.location.href = process.env.RAZZLE_APP_BASE_URL;
    // router.push('/');
  };

  return (
    <Menu
      id="profile-menu"
      anchorEl={menuAnchorEl}
      open={showProfileMenu}
      onClose={handleMenuClose}
      sx={{ fontSize: menuFontSize }}
    >
      <Typography
        variant="h4"
        component="h2"
        color="#0e3f6c"
        style={{
          fontFamily: "Jost",
          padding: "0 12px",
          fontWeight: "500",
        }}
      >
        Hi,&nbsp;{customerDetails?.fullname ?? "Guest"}
      </Typography>
      {menuItems.map(({ name, href, Icon }, index) => {
        // console.log("Menu Item", name);
        return (
          <MenuItem onClick={() => handleItemClick(href, index)} key={index}>
            <ListItemIcon key={index}>
              <img src={Icon} style={{ width: "2.7em", height: "auto" }} />
            </ListItemIcon>
            <ListItemText
              sx={{
                "& .MuiTypography-root": {
                  fontSize: "1.6em",
                  fontFamily: "Jost",
                  color: "#696969",
                },
              }}
            >
              {name}
            </ListItemText>
            <ListItemIcon
              sx={{
                alignSelf: "center",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <ArrowForwardIosIcon />
            </ListItemIcon>
          </MenuItem>
        );
      })}
      <MenuItem onClick={handleLogout}>
        <ListItemIcon sx={{ fontSize: "2.7em", color: "#a7a7a7" }}>
          <RiLogoutBoxLine />
        </ListItemIcon>
        <ListItemText
          sx={{
            "& .MuiTypography-root": {
              fontSize: "1.6em",
              fontFamily: "Jost",
              color: "#696969",
            },
          }}
        >
          Logout
        </ListItemText>
        <ListItemIcon
          sx={{
            alignSelf: "center",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <ArrowForwardIosIcon />
        </ListItemIcon>
      </MenuItem>
    </Menu>
  );
};

ProfileMenu.defaultProps = {
  showProfileMenu: false,
  setShowProfileMenu: () => { },
  anchorEl: null,
  menuFontSize: "1rem",
};

export default ProfileMenu;
